import Typography from 'components/gruenland/atoms/typography';
import { InfoField } from './info-card';

type InfoFieldsProps = {
  fields: Array<InfoField>;
};

const InfoFields: React.FC<InfoFieldsProps> = ({ fields }) => {
  return (
    <div className="grid gap-6">
      {fields?.map(({ label, value }, index) => {
        return value ? (
          <div key={index} className="grid gap-3">
            <Typography className="text-[14px] font-medium leading-loose text-primary-black">{label}</Typography>
            <Typography className="text-[14px] leading-loose text-primary-black">{value}</Typography>
          </div>
        ) : (
          <div key={index}></div>
        );
      })}
    </div>
  );
};

export default InfoFields;
